<template>
  <div class="huaiContainer">
    <full-page :options="options" ref="fullpage">
      <div class="section pageBox1">
        <!-- 导航 -->
        <div class="navBar">
          <img
            class="navLogo"
            src="../assets/logo2.png"
            alt=""
            @click="enterHome()"
          />
          <ul class="navBarItem">
            <!-- <li class="busiz-active-sel">
              <router-link exact to="/" tag="a">首页</router-link>
            </li> -->
            <li>
              <router-link to="/aboutlanshu" exact tag="a"
                >关于兰树</router-link
              >
            </li>
            <el-dropdown>
              <li class="brandLi">
                <router-link
                  exact
                  to="/huaiBrand"
                  style="font-size:0.9em;"
                  tag="a"
                  >兰树品牌</router-link
                >
              </li>
              <el-dropdown-menu
                class="elDropdown"
                exact
                slot="dropdown"
                style="background:rgb(236,245,255)!important;"
              >
                <el-dropdown-item>
                  <li>
                    <router-link
                      :class="brandActive == '1' ? 'elDropdown_active' : ''"
                      style="background:rgb(236,245,255) !important; color: #000 !important;"
                      to="/huaiBrand"
                      tag="a"
                      >淮树</router-link
                    >
                  </li>
                </el-dropdown-item>
                <el-dropdown-item>
                  <li>
                    <router-link
                      :class="brandActive == '2' ? 'elDropdown_active' : ''"
                      style="background:rgb(236,245,255) !important; color: #000 !important;"
                      to="/brand"
                      tag="a"
                      >心清堂</router-link
                    >
                  </li>
                </el-dropdown-item>
                <el-dropdown-item>
                  <li>
                    <router-link
                      :class="brandActive == '3' ? 'elDropdown_active' : ''"
                      style="background:rgb(236,245,255) !important; color: #000 !important;"
                      to="/shuiBrand"
                      tag="a"
                      >水姻缘</router-link
                    >
                  </li>
                </el-dropdown-item>
                <el-dropdown-item>
                  <li>
                    <router-link
                      :class="brandActive == '4' ? 'elDropdown_active' : ''"
                      style="background:rgb(236,245,255) !important; color: #000 !important;"
                      to="/yiBrand"
                      tag="a"
                      >一清堂</router-link
                    >
                  </li>
                </el-dropdown-item>
                <el-dropdown-item
                  ><li>
                    <router-link
                      :class="brandActive == '5' ? 'elDropdown_active' : ''"
                      style="background:rgb(236,245,255) !important; color: #000 !important;"
                      to="/zhongBrand"
                      tag="a"
                      >Dr.CHUNG<span style="vertical-align: super;"
                        >+</span
                      ></router-link
                    >
                  </li></el-dropdown-item
                >
                <el-dropdown-item>
                  <li>
                    <router-link
                      :class="brandActive == '6' ? 'elDropdown_active' : ''"
                      style="background:rgb(236,245,255) !important; color: #000 !important;"
                      to="/lanshuBrand"
                      tag="a"
                      >兰树</router-link
                    >
                  </li>
                </el-dropdown-item>
                <el-dropdown-item>
                  <li>
                    <router-link
                      :class="brandActive == '6' ? 'elDropdown_active' : ''"
                      style="background:rgb(236,245,255) !important; color: #000 !important;"
                      to="/zbqfBrand"
                      tag="a"
                      >植本清方</router-link
                    >
                  </li>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <li>
              <router-link to="/park" exact tag="a">智慧园区</router-link>
            </li>
            <li>
              <router-link to="/brandLanshu" exact tag="a"
                >美业菩提</router-link
              >
            </li>
            <li>
              <router-link to="/school" exact tag="a">兰树商学院</router-link>
            </li>

            <li>
              <router-link to="/dynamicLanshu" exact tag="a"
                >菩提基金会</router-link
              >
            </li>

            <li>
              <router-link to="/lanshuTrends" exact tag="a"
                >兰树动态</router-link
              >
            </li>
          </ul>
        </div>

        <div class="topBgBox" @click="enterProducts(1)">
          <img
            class="topBgBoxImg"
            src="../assets/huaiBrand/huaishuTopNew.png"
            alt=""
          />
        </div>
      </div>

      <div class="section pageBox2">
        <div class="newPageBoxMain2">
          <div class="newPageBoxMainLeft">
            <img
              src="../assets/huaiBrand/brandStory.png"
            />
          </div>

        </div>
      </div>


      <div class="section pageBox3">
        <div class="goTop" @click="scrollToTop"></div>

        <div class="pageBox3Bottom">
            <img
              src="../assets/huaiBrand/bottom.png"
            />
        </div>

        <div class="pageNewBoxRight">
          <div class="pageNewBoxRightText">
            <img
              src="../assets/huaiBrand/biaoshiContent.png"
            />
          </div>
          <div class="biaozhiImg">
            <img
              src="../assets/huaiBrand/pingpaiBiaozhi.png"
            />
          </div>
        </div>
      </div>




      <div class="section pageBox4">
        <div class="goTop" @click="scrollToTop"></div>
        <div class="mainNewPage4">

            <div class="mainNewPageText4">
              <img
                src="../assets/huaiBrand/brandYoulai.png"
              />
            </div>

        </div>
      </div>

      <div class="section pageBox5">
        <div class="goTop" @click="scrollToTop"></div>
        <div class="pageBoxMain5">
          <div class="pageBoxMainRight2">
            <img src="../assets/huaiBrand/brandLiNian.png" alt="">
          </div>
        </div>
      </div>

      <div class="section pageBox6">
        <div class="goTop" @click="scrollToTop"></div>
        <div class="newpageMainBox6">
          <div class="newpageMainBoxImg">
            <img
              src="../assets/huaiBrand/fazhanshiImg.png"
            />
          </div>
          <div class="circleDataBox">
            <div class="background_img"></div>


            <div class="year2010 yearImg">
              <img src="../assets/huaiBrand/2010.png" alt="">
            </div>
            <div class="year2014 yearImg" >
              <img src="../assets/huaiBrand/2014.png" alt="">
            </div>
            <div class="year2015 yearImg" >
              <img src="../assets/huaiBrand/2015.png" alt="">
            </div>
            <div class="year2016 yearImg" >
              <img src="../assets/huaiBrand/2016.png" alt="">
            </div>
            <div class="year2017 yearImg" >
              <img src="../assets/huaiBrand/2017.png" alt="">
            </div>
            <div class="year2018 yearImg" >
              <img src="../assets/huaiBrand/2018.png" alt="">
            </div>
            <div class="year2021 yearImg" >
              <img src="../assets/huaiBrand/2021.png" alt="">
            </div>
            <div class="year2024 yearImg" >
              <img src="../assets/huaiBrand/2024.png" alt="">
            </div>
          </div>

        </div>
      </div>

      <div class="section pageBox7">
        <div class="goTop" @click="scrollToTop"></div>
        <div class="pageNewmain7">
          <div class="pageNewMainText7">
            <img src="../assets/huaiBrand/keyanImg.png" />
          </div>

        </div>
      </div>

      <div class="section pageBox8">
        <div class="goTop" @click="scrollToTop"></div>
        <!-- <div class="seriesTitle">淮树四大系列产品</div> -->
        <div class="seriesMainBox">
          <div class="seriesMainBoxItem seriesMainBoxItem1">
            <img
              class="seriesItemImg1 seriesItemImg"
              src="../assets/huaiBrand/newHuaiC1.png"
              alt=""
              @click="enterProducts(1)"
            />
          </div>
          <div class="seriesMainBoxItem seriesMainBoxItem2">
            <img
              class="seriesItemImg2 seriesItemImg"
              src="../assets/huaiBrand/newHuaiC2.png"
              alt=""
              @click="enterProducts(1)"
            />
          </div>
          <div class="seriesMainBoxItem seriesMainBoxItem3">
            <img
              class="seriesItemImg3 seriesItemImg"
              src="../assets/huaiBrand/newHuaiC3.png"
              alt=""
              @click="enterProducts(1)"
            />
          </div>
          <div class="seriesMainBoxItem seriesMainBoxItem4">
            <img
              class="seriesItemImg4 seriesItemImg"
              src="../assets/huaiBrand/newHuaiC4.png"
              alt=""
              @click="enterProducts(1)"
            />
          </div>
          <div class="seriesMainBoxItem seriesMainBoxItem5">
            <img
              class="seriesItemImg5 seriesItemImg"
              src="../assets/huaiBrand/newHuaiC5.png"
              alt=""
              @click="enterProducts(1)"
            />
          </div>
          <div class="seriesMainBoxItem seriesMainBoxItem6">
            <img
              class="seriesItemImg6 seriesItemImg"
              src="../assets/huaiBrand/newHuaiC6.png"
              alt=""
              @click="enterProducts(1)"
            />
          </div>
          <div class="seriesMainBoxItem seriesMainBoxItem7">
            <img
              class="seriesItemImg7 seriesItemImg"
              src="../assets/huaiBrand/newHuaiC7.png"
              alt=""
              @click="enterProducts(1)"
            />
          </div>

        </div>
      </div>

      <div class="section pageBox9">
        <div class="goTop" @click="scrollToTop"></div>
        <div class="pageBoxOut2">
          <!-- 底部 -->
          <div class="footerBox">
            <div class="footerBoxHeader">
              <div class="footerBoxHeaderLeft">
                <img class="codeImg" src="../assets/code.png" alt="" />
                <span class="codeText">兰树公众号</span>
              </div>
              <div class="footerBoxHeaderRight">
                <img class="codeImg" src="../assets/xcxNew.jpg" alt="" />
                <span class="codeText">兰树云小程序</span>
              </div>
              <!-- <div class="footerBoxHeaderRight">
								<img class="codeImg" src="../assets/code.png" alt="">
								<span class="codeText">兰树客服(QQ)</span>
							</div> -->
            </div>
            <div class="footerMainBox">
              <li class="footerShop">
                <a
                  target="_blank"
                  href="https://huaishu.tmall.com/shop/view_shop.htm?spm=a230r.7195193.1997079397.2.124378dduXIhiW"
                  >淮树旗舰店</a
                >
              </li>
              <li class="footerShop">
                <a
                  target="_blank"
                  href="https://shop537937985.taobao.com/?spm=a230r.7195193.1997079397.2.374448f3jcdl9s"
                  >心清堂官方企业店</a
                >
              </li>
              <li class="footerShop">
                <a target="_blank" href="https://shop349169226.taobao.com/?spm=a21xtw.29978516.0.0"
                  >水姻缘旗舰店</a
                >
              </li>
              <li class="footerShop">
                <a
                  target="_blank"
                  href="https://shop537937985.taobao.com/?spm=a230r.7195193.1997079397.2.374448f3jcdl9s"
                  >一清堂官方企业店</a
                >
              </li>
              <li class="footerShop">
                <a target="_blank" href="https://drchung.tmall.com"
                  >Dr.CHUNG<span style="vertical-align: super;">+</span
                  >旗舰店</a
                >
              </li>
              <li class="footerShop">
                <a target="_blank" href="https://zhibenqingfang.tmall.com"
                  >植本清方旗舰店</a
                >
              </li>
              <div class="lastHeader">
                <li>
                  <router-link to="/login" tag="a">登录</router-link>
                </li>
                |
                <li>
                  <router-link to="/login" tag="a">注册</router-link>
                </li>
              </div>
            </div>

            <div class="footerInfoBox">
              <div class="emailBox">邮箱: postermaster@lasur.com</div>
              <div class="phoneBox">电话: 0571-89025888</div>
              <div class="addressBox">
                地址: 浙江省杭州市之江东路越秀·维多利中心A座 17楼
              </div>
            </div>

            <div class="footerLine"></div>
            <div class="footerBoxBottom">
              <div class="footerLeft">
                Copyright © 2023 兰树化妆品股份有限公司
                <a
                  target="_blank"
                  href="https://beian.miit.gov.cn/#/Integrated/index"
                  >浙ICP备20018890号-1</a
                >
                | <img height="16px" src="../assets/plice.png" />&nbsp;<a
                  target="_blank"
                  href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33052102000740"
                  >浙公网安备 33052102000740号</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </full-page>
  </div>
</template>

<script>
export default {
  data() {
    return {
      screenWidth: window.innerWidth,
      screenHeight: window.innerHeight,
      circleItemBox: [
        "circleItemBox0",
        "circleItemBox1",
        "circleItemBox2",
        "circleItemBox3",
        "circleItemBox4",
        "circleItemBox5",
        "circleItemBox6"
      ],
      chooseIndex: 0,
      timePosition: [
        -6.96,
        -5.42,
        -3.9,
        -2.35,
        -0.79,
        0.74,
        2.27,
        3.82,
        5.37,
        6.93
      ],
      options: {
        licenseKey: "OPEN-SOURCE-GPLV3-LICENSE",
        //是否显示导航，默认为false
        navigation: true
      },
      brandActive: 1,
      circleData: [
        {
          id: 1,
          year: "2010",
          content: "淮树品牌上线*"
        },
        {
          id: 2,
          year: "2014",
          content: "创新品质,推出私人订制修护产品。"
        },
        {
          id: 3,
          year: "2015",
          content: "推出原生赋活套，费者喜欢。"
        },
        {
          id: 4,
          year: "2016",
          content: "创立美业菩提节并于8月8日在上海成功举办。"
        },
        {
          id: 5,
          year: "2017",
          content:
            "举办第二届美业菩提节，参会人数近4000人，再次掀起美业新高潮。"
        },
        {
          id: 6,
          year: "2018",
          content:
            "兰树落户湖州市德清国家级高新区,用地约 85 亩,总投资人民币 5.5 亿元。"
        },
        {
          id: 7,
          year: "2021",
          content: "淮树品牌全面年轻化升级上线*"
        }
      ]
    };
  },
  mounted() {
    // console.log('start', this.$refs.bannerHeight);
    this.imgLoad();
    window.addEventListener(
      "resize",
      () => {
        // this.bannerHeight = this.$refs.bannerHeight[0].height;
        this.imgLoad();
      },
      false
    );
    this.updateScreenSize();
    window.addEventListener('resize', this.updateScreenSize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateScreenSize);
  },
  methods: {
    updateScreenSize() {
      this.screenWidth = window.innerWidth;
      this.screenHeight = window.innerHeight;
    },
    scrollToTop() {
      fullpage_api.moveTo(1);
    },
    enterProducts(id) {
      this.$router.push({ path: "/productsList", query: { brandId: id } });
    },
    enterHome() {
      this.$router.push({ path: "/" });
    },
    imgLoad() {
      // console.log('brandId', this.brandId);
      this.$nextTick(() => {
        // this.bannerHeight = this.$refs.bannerHeight[0].height;
        // console.log(this.$refs.bannerHeight[0].height);
      });
    }
  }
};
</script>

<style scoped>
.goTop {
  width: 2.6vw;
  height: 5.38vh;
  background: url(../assets/newLasur/goTop.png) no-repeat;
  background-position: 50% 50%;
  background-size: 100%;
  overflow: hidden;
  position: absolute;
  right: 3.8vw;
  bottom: 9.25vh;
  cursor: pointer;
  z-index: 999;
}
.goTop:hover {
  background: url(../assets/newLasur/goTop2.png) no-repeat;
  background-position: 50% 50%;
  background-size: 100%;
  overflow: hidden;
}
.huaiContainer {
  margin: 0;
  padding: 0;
  position: relative;
}

.pageBoxOut2 {
  width: 100%;
  height: 100%;
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  box-sizing: border-box;
}

/* 导航 */

/* 下拉菜单栏 选中 */
.elDropdown_active {
  background-color: #ffffff !important;
  color: #000000 !important;
}

.navBar {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: absolute;
  justify-content: space-between;
  top: 0;
  background: #ffffff;
  /* border-bottom:1px solid rgba(255,255,255,0.2); */
  z-index: 999;
}

.router-link-active {
  background-color: #0f3f93 !important;
  color: #ffffff !important;
}

.navLogo {
  width: 10%;
  margin-left: 5em;
  cursor: pointer;
}

.navBarItem {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}

.navBarItem li {
  /* list-style: none;
		padding: 1.5em 2.5em 1.5em 2.5em;
		float: left; */
  list-style: none;
  /* padding: 25px 40px 25px 40px; */
  float: left;
  /* margin-left: 2em; */
}

.brandLi a {
  text-decoration: none;
  font-size: 0.875em;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #222222;
  line-height: 20px;
  padding-top: 1.6em !important;
  padding-bottom: 1.6em !important;
  padding-left: 2em;
  padding-right: 2em;
}

.navBarItem li a {
  text-decoration: none;
  font-size: 0.875em;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #222222;
  line-height: 20px;
  padding-top: 1.3em;
  padding-bottom: 1.3em;
  padding-left: 1.4rem;
  padding-right: 1.4rem;
}

/* .elDropdown{
		margin-left: -7.5em;
		margin-top: -1em;
	} */

.elDropdown a {
  color: #111111;
  text-decoration: none;
}

.el-dropdown {
  vertical-align: top;
}

.el-dropdown + .el-dropdown {
  margin-left: 15px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.el-dropdown-link {
  cursor: pointer;
}

.el-icon-arrow-down {
  font-size: 12px;
}

/* pageBox1 */
.pageBox1 {
  width: 100%;
  /* background: url(https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2021-03-30_09-33-18_16066.jpeg) no-repeat; */
  background: url(../assets/huaiBrand/newhuaishu.jpg) no-repeat;
  background-position: 50% 80%;
  background-size: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
}

.topBgBox {
  width: 28%;
  position: absolute;
  top: 18%;
  left: 0%;
  opacity: 0.2;
  cursor: pointer;
  -moz-transition: 1.5s;
  -webkit-transition: 1.5s;
  animation: topbgbox 1.5s;
  -webkit-animation: topbgbox 1.5s;
}

.topBgBoxImg {
  width: 100%;
  height: 100%;
}

.pageBox1.active .topBgBox {
  left: 12%;
  opacity: 1;
}

/* 动画 topbgbox */
/* first 图1动画 */
@keyframes topbgbox {
  from {
    opacity: 0;
    right: 0;
  }

  to {
    opacity: 1;
    /* right:30%;} */
    left: 12%;
  }
}

@-webkit-keyframes topbgbox

/* Safari 和 Chrome */ {
  from {
    opacity: 0;
    right: 0;
  }

  to {
    opacity: 1;
    left: 12%;;
  }

  /* right:30%;} */
}

/* pageBox2 */
.pageBox2 {
  width: 100%;

  background: url(../assets/huaiBrand/newBg2.jpg) no-repeat;
  /* background: url(https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2021-03-29_17-38-22_99263.jpeg) no-repeat; */
  background-position: center 60%;
  background-size: 100%;
  display: flex;
  flex-direction: column;
}

.carouselImg {
  width: 100%;
  /* height:320px; */
  height: 40%;
}

.newPageBoxMain2 {
  width: 100%;
  height: 100%;
  position: relative;
}

.brandStoryImg {
  margin-left: 100px;
  padding-top: 50px;
}



.newPageBoxMainLeft {
  width: 40%;
  position: absolute;
  opacity: 0.5;
  top: 19%;
  left: 0;
  -moz-transition: 1.5s;
  -webkit-transition: 1.5s;
  animation: newPageBoxMainLeft 1.5s;
  -webkit-animation: newPageBoxMainLeft 1.5s;
}

.newPageBoxMainLeft img{
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.pageBox2.active .newPageBoxMainLeft {
  left: 12%;
  opacity: 1;
}

@keyframes newPageBoxMainLeft {
  from {
    opacity: 0;
    left: 0;
  }

  to {
    opacity: 1;
    left: 12%;
  }
}

@-webkit-keyframes newPageBoxMainLeft

/* Safari 和 Chrome */ {
  from {
    opacity: 0;
    left: 0;
  }

  to {
    opacity: 1;
    left: 12%;
  }
}

/* .pageBox2{
	    	width: 100%;
	    	background: url(https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2021-03-29_17-38-22_99263.jpeg) no-repeat;
	    	background-position:center 60%;
	    	background-size: 100%;
	    	display: flex;
	    	flex-direction:column;
	  	    align-items: center;
	  }
    */

/* pageBox3 */

.pageBox3 {
  width: 100%;
	    	background: url(../assets/huaiBdNew3.jpg) no-repeat;
	    	background-size: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.pageTopTitle {
  font-size: 2.2rem;
  font-family: SimSun;
  font-weight: bold;
  color: #222222;
  line-height: 20px;
  text-align: center;
}

.pageBoxMainBody3 {
  width: 80%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 5%;
}

.itemBox1 {
  display: flex;
  flex-direction: column;
  position: relative;
  top: -5rem;
  opacity: 0.5;
  -moz-transition: 1.5s;
  -webkit-transition: 1.5s;
}

.pageBox3.active .itemBox1 {
  top: 0;
  opacity: 1;
}


.secondNewImg {
  position: relative;
  bottom: -500px;
  opacity: 0;
  -moz-transition: 1.5s;
  -webkit-transition: 1.5s;
  animation: secondNewImg 1.5s;
  -webkit-animation: secondNewImg 1.5s;
}

.pageBox3.active .secondNewImg {
  bottom: 0;
  opacity: 1;
}

@keyframes secondNewImg {
  from {
    opacity: 0;
    bottom: -500px;
  }

  to {
    opacity: 1;
    bottom: 0;
  }
}

@-webkit-keyframes secondNewImg

/* Safari 和 Chrome */ {
  from {
    opacity: 0;
    bottom: -500px;
  }

  to {
    opacity: 1;
    bottom: 0;
  }
}

.itemBoxTitle1 {
  font-size: 1.2rem;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #111111;
  font-weight: 400;
  line-height: 25px;
  margin-top: 1rem;
}

.itemBoxImg {
  width: 100%;
}

.itemBoxImg1 {
  width: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.itemBoxImg2 {
  width: 85%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.addImg {
  width: 100%;
}

.addBox {
  margin-left: 7%;
}

.itemBox2 {
  margin-left: 9%;
}

.itemBox3 {
  margin-left: 7%;
}

.pageBoxMainBodyBottom {
  font-size: 1.1rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #111111;
  line-height: 25px;
  width: 50%;
  margin: 0 auto;
  text-align: center;
  position: relative;
  top: 40%;
  opacity: 0.5;
  -moz-transition: 1.5s;
  -webkit-transition: 1.5s;
}

.pageBox3Bottom {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
}

.pageBox3Bottom img{
  width: 100%;
}


.pageNewBoxRightText {
  width: 20%;
  position: absolute;
  top: 10%;
  right: 0%;
  -moz-transition: 1.5s;
  -webkit-transition: 1.5s;
  animation: pageNewBoxRightText 1.5s;
  -webkit-animation: pageNewBoxRightText 1.5s;
}
.pageNewBoxRightText img{
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.pageBox3.active .pageNewBoxRightText {
  right: 20%;
}

@keyframes pageNewBoxRightText {
  from {
    right: 0%;
  }

  to {
    right: 20%;
  }
}

@-webkit-keyframes pageNewBoxRightText

/* Safari 和 Chrome */ {
  from {
    right: 0%;
  }

  to {
    right: 20%;
  }
}

.biaozhiImg {
  width: 20%;
  position: absolute;
  top: 12%;
  left: 0;
  -moz-transition: 1.5s;
  -webkit-transition: 1.5s;
  animation: biaozhiImg 1.5s;
  -webkit-animation: biaozhiImg 1.5s;
}
.biaozhiImg img{
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.pageBox3.active .biaozhiImg {
  left: 20%;
}

@keyframes biaozhiImg {
  from {
    left: 0%;
  }

  to {
    left: 20%;
  }
}

@-webkit-keyframes biaozhiImg

/* Safari 和 Chrome */ {
  from {
    left: 0%;
  }

  to {
    left: 20%;
  }
}

/* .pageBox3.active .pageBoxMainBodyBottom{
		  top: 8%;
		  opacity: 1;
	  }
 */
/* pageBox4 */

.pageBox4 {
  width: 100%;
	    	background: url(../assets/huaiBrand/huaiBdNew4.jpg) no-repeat;
	    	background-position:50% 50%;
	    	background-size: 100%;
	    	display: flex;
	    	flex-direction:column;
	  	align-items: auto;
      /* background-position: 50% 80%;
  background-size: 100%;
  display: flex;
  flex-direction: column;
  position: relative; */
}

.pageBoxMain4 {
  width: 80%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 12%;
}

.flowerBox1 {
  width: 13%;
  position: absolute;
  float: left;
  left: 0;
  bottom: 0;
  z-index: 999;
}

.flowerBox2 {
  width: 13%;
  position: absolute;
  float: right;
  right: 0;
  bottom: 0;
  z-index: 999;
}

.flowerImg2 {
  width: 100%;
}

.flowerImg1 {
  width: 100%;
}

.pageBoxMainLeft {
  width: 45%;
}

.pageBoxMainImg {
  width: 100%;
}

.pageBoxMainRight {
  width: 35%;
  display: flex;
  flex-direction: column;
  position: relative;
  left: 25rem;
  opacity: 0.5;
  -moz-transition: 1.5s;
  -webkit-transition: 1.5s;
}

.pageBox4.active .pageBoxMainRight {
  left: 8rem;
  opacity: 1;
}

.pageBoxMainRightTop {
  font-size: 2rem;
  font-family: simsun;
  color: #ffffff;
  font-weight: bold;
  line-height: 33px;
  letter-spacing: 1px;
}

.pageBoxMainRightBottom {
  font-size: 1.125rem;
  opacity: 0.9;
  color: #ffffff;
  line-height: 46px;
  margin-top: 1rem;
}


.mainNewPageText4 {
  width: 35%;
  position: absolute;
  top:-200px;
  right: 18%;
  opacity: 0;
  -moz-transition: 1.5s;
  -webkit-transition: 1.5s;
  animation: mainNewPageText4 1.5s;
  -webkit-animation: mainNewPageText4 1.5s;
}
.mainNewPageText4 img{
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.pageBox4.active .mainNewPageText4 {
  top: 12%;
  opacity: 1;
}

@keyframes mainNewPageText4 {
  from {
    opacity: 0;
    top:-200px;
  }

  to {
    opacity: 1;
    top: 10%;
  }
}

@-webkit-keyframes mainNewPageText4

/* Safari 和 Chrome */ {
  from {
    opacity: 0;
    top:-200px;
  }

  to {
    opacity: 1;
    top: 10%;
  }
}

.mainNewPageRight4 {
  width: 45%;
  display: flex;
  flex-direction: column;
  margin-left: 100px;
}

.shanziImgBox {
  position: relative;
  left: 65%;
}

.bottomImgBox {
}

.outFlex {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

/* pageBox5 */

.pageBox5 {
  width: 100%;
  /* background-color: #103a26; */
  background: url(../assets/huaiBrand/huiaBdNew5.jpg) no-repeat;
  background-position: 50% 50%;
  background-size: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.pageBoxMain5 {
  width: 90%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 12%;
}

.pageBoxMainLeft2 {
  width: 40%;
}

.pageBoxMainImg {
  width: 100%;
}

.pageBoxMainRight2 {
  width: 35%;
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 13%;
  left: -20rem;
  opacity: 0;
  -moz-transition: 1.5s;
  -webkit-transition: 1.5s;
}

.pageBox5.active .pageBoxMainRight2 {
  left: 25%;
  opacity: 1;
}

.pageBoxMainRightTop2 {
  font-size: 2rem;
  font-family: simsun;
  font-weight: bold;
  color: #111111;
  line-height: 33px;
  letter-spacing: 1px;
}

.pageBoxMainRightBottom2 {
  font-size: 1.125rem;
  font-family: PingFangSC-Regular, PingFang SC;
  opacity: 0.9;
  color: #111111;
  line-height: 46px;
  margin-top: 1rem;
}

.linianText {
  font-size: 18px;
  margin-top: 20px;
  color: #ffffff;
  letter-spacing: 5px;
  line-height: 40px;
}

.linianTextBottom {
  margin-top: 10px;
  color: #ffffff;
  line-height: 20px;
  font-size: 10px;
  opacity: 0.7;
}

/* pageBox6 */
.pageBox6 {
  width: 100%;
  /* background: url(../assets/huaiBrand/huiaBdNew6.jpg)
    no-repeat;

  background-size: 100%;
  display: flex;
  flex-direction: column; */
  position: relative;
}

.newpageMainBox6 {
  width: 100%;
}

.newpageMainBoxImg {
  position: absolute;
  top: 8%;
  left: 8%;
  width: 30%;
}

.newpageMainBoxImg img{
  width: 100%;
  height: 100%;
  object-fit: contain;
}


/* pageBox7 */
.pageBox7 {
  width: 100%;
  background: url(../assets/huaiBrand/huiaBdNew7.jpg)
  no-repeat;
  /* background: url(https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2021-03-29_17-38-22_99263.jpeg) no-repeat; */
  /* background-position:center 100%; */
  background-size: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* .pageNewmain7 {
  display: flex;
  flex-direction: row;
  position: absolute;
  right: 10px;
} */

.pageNewMainText7 {
  width: 32%;
  position: absolute;
  top: 10%;
  right: 50%;
  opacity: 0.2;
  -moz-transition: 1.5s;
  -webkit-transition: 1.5s;
  animation: pageNewMainText7 1.5s;
  -webkit-animation: pageNewMainText7 1.5s;
}
.pageNewMainText7 img{
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.pageBox7.active .pageNewMainText7 {
  right: 10%;
  opacity: 1;
}

/* @keyframes pageNewMainText7 {
  from {
    opacity: 0;
    left: -500px;
  }

  to {
    opacity: 1;
    left: 0;
  }
}

@-webkit-keyframes pageNewMainText7 {
  from {
    opacity: 0;
    left: -500px;
  }

  to {
    opacity: 1;
    left: 0;
  }
} */

.circleDataBox {
  width: 100%;

}
.background_img{
  background: url(../assets/huaiBrand/huiaBdNew6.jpg) no-repeat center center;
  background-size: contain;
  width: 100%;
  height: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: -1;
}

.yearImg{
  width: 4%;
  position: absolute;

}
.pageBox6.active .yearImg{
  bottom: 100%;
  opacity: 0;
  animation: dropDown 1s ease forwards;
  /* 从 data-delay 属性获取动画延迟 */

}


@keyframes dropDown {
  from {
    bottom: 100%;
    opacity: 0;
  }
  to {
     /* 计算最终的 top 位置，使用 calc 结合 bottom 值 */
    bottom: var(--bottom);
    opacity: 1;
  }
}
.yearImg img{
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.year2010{
  /* position: absolute; */
  --bottom: 39.8%;
  animation-delay:0.2s !important;
  left: 8.8%;
}
.year2014{
  /* position: absolute; */
  --bottom: 37.5%;
  animation-delay:0.4s !important;
  left: 19.6%;
}
.year2015{
  /* position: absolute; */
  --bottom: 33.9%;
  animation-delay:0.6s !important;
  left: 30.5%;
}
.year2016{
  /* position: absolute; */
  --bottom: 36%;
  animation-delay:0.8s !important;
  left: 41.8%;
}
.year2017{
  /* position: absolute; */
  --bottom: 33.4%;
  animation-delay:1s !important;
  left: 52.9%;
}
.year2018{
  /* position: absolute; */
  --bottom: 41%;
  animation-delay:1.2s !important;
  left: 65%;
}
.year2021{
  /* position: absolute; */
  --bottom: 48.2%;
  animation-delay:1.4s !important;
  left: 75.8%;
}
.year2024{
  /* position: absolute; */
  --bottom: 44.2%;
  animation-delay:1.6s !important;
  left: 84.8%;
}

.circleItemBox0 {
  z-index: 999;
  position: relative;
  top: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  -moz-transition: 1.5s;
  -webkit-transition: 1.5s;
  animation: circleItemBox0 1.5s;
  -webkit-animation: circleItemBox0 1.5s;
}

.pageBox6.active .circleItemBox0 {
  top: -100px;
  opacity: 1;
}

@keyframes circleItemBox0 {
  from {
    opacity: 0;
    top: 100px;
  }

  to {
    opacity: 1;
    top: -100px;
  }
}

@-webkit-keyframes circleItemBox0

/* Safari 和 Chrome */ {
  from {
    opacity: 0;
    top: 100px;
  }

  to {
    opacity: 1;
    top: -100px;
  }
}

.circleItemBox1 {
  z-index: 999;
  position: relative;
  top: -200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  -moz-transition: 1.5s;
  -webkit-transition: 1.5s;
  animation: circleItemBox1 1.5s;
  -webkit-animation: circleItemBox1 1.5s;
}

.pageBox6.active .circleItemBox1 {
  top: -100px;
  opacity: 1;
}

@keyframes circleItemBox1 {
  from {
    opacity: 0;
    top: -200px;
  }

  to {
    opacity: 1;
    top: -100px;
  }
}

@-webkit-keyframes circleItemBox1

/* Safari 和 Chrome */ {
  from {
    opacity: 0;
    top: -200px;
  }

  to {
    opacity: 1;
    top: -100px;
  }
}

.circleItemBox2 {
  z-index: 999;
  position: relative;
  top: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  -moz-transition: 1.5s;
  -webkit-transition: 1.5s;
  animation: circleItemBox2 1.5s;
  -webkit-animation: circleItemBox2 1.5s;
}

.pageBox6.active .circleItemBox2 {
  top: -100px;
  opacity: 1;
}

@keyframes circleItemBox2 {
  from {
    opacity: 0;
    top: 100px;
  }

  to {
    opacity: 1;
    top: -100px;
  }
}

@-webkit-keyframes circleItemBox2

/* Safari 和 Chrome */ {
  from {
    opacity: 0;
    top: 100px;
  }

  to {
    opacity: 1;
    top: -100px;
  }
}

.circleItemBox3 {
  z-index: 999;
  position: relative;
  top: -200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  -moz-transition: 1.5s;
  -webkit-transition: 1.5s;
  animation: circleItemBox3 1.5s;
  -webkit-animation: circleItemBox3 1.5s;
}

.pageBox6.active .circleItemBox3 {
  top: -100px;
  opacity: 1;
}

@keyframes circleItemBox3 {
  from {
    opacity: 0;
    top: -200px;
  }

  to {
    opacity: 1;
    top: -100px;
  }
}

@-webkit-keyframes circleItemBox3

/* Safari 和 Chrome */ {
  from {
    opacity: 0;
    top: -200px;
  }

  to {
    opacity: 1;
    top: -100px;
  }
}

.circleItemBox4 {
  z-index: 999;
  position: relative;
  top: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  -moz-transition: 1.5s;
  -webkit-transition: 1.5s;
  animation: circleItemBox4 1.5s;
  -webkit-animation: circleItemBox4 1.5s;
}

.pageBox6.active .circleItemBox4 {
  top: -100px;
  opacity: 1;
}

@keyframes circleItemBox4 {
  from {
    opacity: 0;
    top: 100px;
  }

  to {
    opacity: 1;
    top: -100px;
  }
}

@-webkit-keyframes circleItemBox4

/* Safari 和 Chrome */ {
  from {
    opacity: 0;
    top: 100px;
  }

  to {
    opacity: 1;
    top: -100px;
  }
}

.circleItemBox5 {
  z-index: 999;
  position: relative;
  top: -200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  -moz-transition: 1.5s;
  -webkit-transition: 1.5s;
  animation: circleItemBox5 1.5s;
  -webkit-animation: circleItemBox5 1.5s;
}

.pageBox6.active .circleItemBox5 {
  top: -100px;
  opacity: 1;
}

@keyframes circleItemBox5 {
  from {
    opacity: 0;
    top: -200px;
  }

  to {
    opacity: 1;
    top: -100px;
  }
}

@-webkit-keyframes circleItemBox5

/* Safari 和 Chrome */ {
  from {
    opacity: 0;
    top: -200px;
  }

  to {
    opacity: 1;
    top: -100px;
  }
}

.circleItemBox6 {
  z-index: 999;
  position: relative;
  top: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  -moz-transition: 1.5s;
  -webkit-transition: 1.5s;
  animation: circleItemBox6 1.5s;
  -webkit-animation: circleItemBox6 1.5s;
}

.pageBox6.active .circleItemBox6 {
  top: -100px;
  opacity: 1;
}

@keyframes circleItemBox6 {
  from {
    opacity: 0;
    top: 100px;
  }

  to {
    opacity: 1;
    top: -100px;
  }
}

@-webkit-keyframes circleItemBox6

/* Safari 和 Chrome */ {
  from {
    opacity: 0;
    top: 100px;
  }

  to {
    opacity: 1;
    top: -100px;
  }
}

.circleContent {
  height: 240px;
  writing-mode: vertical-rl;
  letter-spacing: 4px;
  line-height: 30px;
  margin-top: 30px;
}



.dotImg {
  width: 20px;
  margin-top: 15px;
}

.yearBox {
  margin-top: -70px;
  font-size: 18px;
}

.pageNewMainImg7 {
  margin-right: 150px;
  margin-top: 100px;
}

/* pageBox8 */
.pageBox8 {
  width: 100%;
  background: url(../assets/huaiBrand/huiaBdNew8.jpg) no-repeat;
  /* background: url(https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2021-03-29_17-38-22_99263.jpeg) no-repeat; */
  background-size: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* pageBox9 */
.pageBox9 {
  width: 100%;
  background-color: #103a26;
  display: flex;
  flex-direction: column;
}

/* footer */
.footerBox {
  width: 90%;
  /* height: 287px; */
  /* position:absolute;
	   	bottom:0; */
  margin: 0 auto;
  flex-direction: column;
  z-index: 999;
}

.footerBoxHeader {
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 2%;
}

.footerBoxHeaderLeft {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.footerBoxHeaderRight {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 5em;
}

.footerBoxHeaderMiddle {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.codeImg {
  width: 100%;
}

.codeText {
  font-size: 0.88em;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 200;
  color: #ffffff;
  line-height: 20px;
  margin-top: 0.5rem;
}

.footerLine {
  width: 79%;
  height: 1px;
  display: flex;
  background: #ffffff;
  opacity: 0.1;
  margin: 0 auto;
  align-items: center;
  margin-top: 1em;
}

.footerInfoBox {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 2rem;
}

.emailBox {
  font-size: 0.875rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 200;
  color: #ffffff;
  line-height: 20px;
}

.phoneBox {
  font-size: 0.875rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 200;
  color: #ffffff;
  line-height: 20px;
  margin-top: 0.5rem;
}

.addressBox {
  font-size: 0.875rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 200;
  color: #ffffff;
  line-height: 20px;
  margin-top: 0.5rem;
}

.footerBoxBottom {
  display: flex;
  margin: 0 auto;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  margin-top: 1rem;
}

.footerLeft {
  font-size: 0.875em;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 200;
  color: #ffffff;
  line-height: 24px;
}

.footerLeft a {
  text-decoration: none;
  cursor: pointer;
  color: #ffffff;
}

.footerLeft a:hover {
  color: #003f98;
}

.footerMiddle {
  display: flex;
  flex-direction: column;
  margin-left: 1em;
}

.footerMiddle span {
  font-size: 0.875em;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 200;
  color: #ffffff;
  line-height: 24px;
}

.footerRight {
  display: flex;
  flex-direction: column;
  margin-left: 1em;
}

.footerRight li a {
  text-decoration: none;
  font-size: 0.875em;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 200;
  color: #ffffff;
  line-height: 28px;
}

.footerRight li {
  list-style: none;
}

.footerLast {
  display: flex;
  flex-direction: column;
  margin-left: 1em;
}

.lastHeader {
  display: flex;
  flex-direction: row;
  font-size: 0.875em;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 200;
  color: #ffffff;
  line-height: 28px;
  margin-left: 2em;
}

.lastHeader li a {
  text-decoration: none;
  font-size: 0.875rm;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 200;
  color: #ffffff;
  line-height: 28px;
}

.lastHeader li {
  list-style: none;
}

.footerLast span {
  font-size: 0.875em;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 200;
  color: #ffffff;
}

.footerMainBox {
  display: flex;
  flex-direction: row;
  margin: 0 auto;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  margin-top: 2em;
}

.footerShop {
  list-style: none;
}

.footerShop a {
  text-decoration: none;
  font-size: 0.875rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 200;
  color: #ffffff;
  padding-left: 2em;
  line-height: 28px;
  cursor: pointer;
}

.seriesTitle {
  margin: 0 auto;
  text-align: center;
  font-size: 2rem;
  margin-top: 2%;
  font-weight: bold;
  font-family: SimSun;
}

.seriesMainBox {
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  /* margin-top: 2%; */
}

.seriesMainBoxItem {
  width: 100%;
}

.seriesItemImg {
  /* width: 30%; */
  cursor: pointer;
}
.seriesItemImg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.seriesItemImg1 {
  width: 2%;
  position: absolute;
  left: 17%;
  top: 24%;
  opacity: 0;

}
.pageBox8.active .seriesItemImg1 {
  -moz-transition: 3s;
  -webkit-transition: 3s;
  animation: showImg 3s;
  -webkit-animation: showImg 3s;
  opacity: 1;
}

@keyframes showImg {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }

}
@-webkit-keyframes showImg{
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}




.seriesItemImg2 {
  width: 2%;
  position: absolute;
  left: 29%;
  top: 33.6%;
  opacity: 0;
}

.pageBox8.active .seriesItemImg2 {
  -moz-transition: 3s;
  -webkit-transition: 3s;
  animation: showImg 3s;
  -webkit-animation: showImg 3s;
  opacity: 1;

}

.seriesItemImg3 {
  width: 2%;
  position: absolute;
  float: right;
  left: 38.6%;
  top: 17%;
  opacity: 0;
}

.pageBox8.active .seriesItemImg3 {
  -moz-transition: 3s;
  -webkit-transition: 3s;
  animation: showImg 3s;
  -webkit-animation: showImg 3s;
  opacity: 1;

}
.seriesItemImg4 {
  width: 2%;
  position: absolute;
  float: right;
  left: 49%;
  top: 23%;
  opacity: 0;
}

.pageBox8.active .seriesItemImg4 {
  -moz-transition: 3s;
  -webkit-transition: 3s;
  animation: showImg 3s;
  -webkit-animation: showImg 3s;
  opacity: 1;

}

.seriesItemImg5 {
  width: 2%;
  position: absolute;
  float: right;
  left: 67.4%;
  top: 30%;
  opacity: 0;

}
.pageBox8.active .seriesItemImg5 {
  -moz-transition: 3s;
  -webkit-transition: 3s;
  animation: showImg 3s;
  -webkit-animation: showImg 3s;
  opacity: 1;
}

.seriesItemImg6 {
  width: 2%;
  position: absolute;
  float: right;
  left: 69%;
  top: 52%;
  opacity: 0;

}
.pageBox8.active .seriesItemImg6 {
  -moz-transition: 3s;
  -webkit-transition: 3s;
  animation: showImg 3s;
  -webkit-animation: showImg 3s;
  opacity: 1;
}

.seriesItemImg7 {
  width: 2%;
  position: absolute;
  float: right;
  left: 86%;
  top: 36%;
  opacity: 0;

}
.pageBox8.active .seriesItemImg7 {
  -moz-transition: 3s;
  -webkit-transition: 3s;
  animation: showImg 3s;
  -webkit-animation: showImg 3s;
  opacity: 1;
}




.busiz-text-ellipes1 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /*autoprefixer: on */
}

.big-circle {
  width: 12000px;
  height: 12000px;
  border: 2px solid #909698;
  box-shadow: 0 0 0px 1px #909698;
  border-radius: 100%;
  position: absolute;
  left: 50%;
  margin-left: -6000px;
  top: 35%;
  transition-duration: 1s;
}

/* .bear{
              width: 100px;
              height: 100px;
              position: absolute;
              left: 50%;
              margin-left: -50px;
              top: -30px;
          } */

.time-shaft {
  width: 100%;
  height: 2px;
  background-color: #909698;
  margin-top: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/huaiBrand.vue